import { AppBundle } from 'api/optimalprint-sdk.d';

type ProductPageSelectorOption =
  AppBundle.Api.Entity.Design.V1.DesignAbstractProduct.ProductPageSelector.IProductPageSelectorOption;

export type ExtendedProductPageSelectorOption = ProductPageSelectorOption & {
  disabled: boolean;
  selected: boolean;
  productId?: number;
  hexColor2?: string;
  avalilabilityStatus?: {
    status: string;
    label: string;
  } | null;
};

const exploreOptions = (options: ExtendedProductPageSelectorOption[]) => {
  const result = {
    totalOptions: options.length,
    availableOptions: 0,
    selectedOptions: 0,
    hasColorOptions: false,
    hasColor2Options: false,
    hasIconOptions: false,
  };
  options.forEach((option) => {
    if (!option.disabled) {
      result.availableOptions += 1;
    }
    if (option.selected) {
      result.selectedOptions += 1;
    }
    if (option.hexColor) {
      result.hasColorOptions = true;
    }
    if (option.hexColor2) {
      result.hasColor2Options = true;
    }
    if (option.iconUrl) {
      result.hasIconOptions = true;
    }
  });
  return result;
};

export default exploreOptions;
